import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { PaymentsRoutingModule } from './payments-routing.module';
import { PaymentsListComponent } from './components/payments-list/payments-list.component';
import { SharedModule } from '../shared/shared.module';
import { PaymentsService } from './services/payments.service';
import { ConstsHelper } from '../../helpers/consts.helper';
import { paymentsReducer } from './store/reducers/payments.reducer';
import { walletReducer } from './store/reducers/wallet.reducer';
import { PaymentsEffects } from './store/effects/payments.effects';
import { WalletEffects } from './store/effects/wallet.effects';
import { PaymentsManagementComponent } from './components/payments-management/payments-management.component';


@NgModule({
    declarations: [PaymentsListComponent, PaymentsManagementComponent],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        PaymentsRoutingModule,
        SharedModule,
        StoreModule.forFeature(ConstsHelper.REDUCER_PAYMENTS, paymentsReducer),
        StoreModule.forFeature(ConstsHelper.REDUCER_WALLET, walletReducer),
        EffectsModule.forFeature([PaymentsEffects, WalletEffects])
    ],
    providers: [PaymentsService],
})
export class PaymentsModule { }
